import { useLocale, useTranslations } from 'use-intl';
import { useMemo } from 'react';
import {
  buildDateFormatters,
  buildNumberFormatters,
  type DateFormatters,
  type NumberFormatters,
  type TimeMessages,
} from './format-date';

export function useFormatDate(): DateFormatters {
  const locale = useLocale();
  const t = useTranslations('Common.time');

  // Resolve each translated string to a primitive so useMemo compares by value,
  // not by `t`'s function reference (which changes every render).
  const justNow = t('justNow');
  const now = t('now');
  const never = t('never');

  return useMemo(() => {
    const msg: TimeMessages = {
      justNow,
      minutesAgo: (count) => t('minutesAgo', { count }),
      hoursAgo: (count) => t('hoursAgo', { count }),
      daysAgo: (count) => t('daysAgo', { count }),
      now,
      minutesShort: (count) => t('minutesShort', { count }),
      hoursShort: (count) => t('hoursShort', { count }),
      daysShort: (count) => t('daysShort', { count }),
      secondsAgo: (count) => t('secondsAgo', { count }),
      never,
    };
    return buildDateFormatters(locale, msg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale, justNow, now, never]);
}

export function useFormatNumber(): NumberFormatters {
  const locale = useLocale();
  return useMemo(() => buildNumberFormatters(locale), [locale]);
}
